import { Moment } from 'moment';
import isStaticDateHoliday from './isStaticDateHoliday';
import isMovableDateHoliday from './isMovableDateHoliday';
import isMemorialDay from './isMemorialDay';

/* Static holidays are days that have the same date every year. */
const staticDateBankHolidays = [
  {
    month: 0,
    date: 1,
    saturdayAdjustment: 0,
    sundayAdjustment: 1,
    locale: 'en-us',
  }, // New Years Day
  {
    month: 5,
    date: 19,
    saturdayAdjustment: 0,
    sundayAdjustment: 1,
    locale: 'en-us',
  }, // Juneteenth
  {
    month: 6,
    date: 4,
    saturdayAdjustment: 0,
    sundayAdjustment: 1,
    locale: 'en-us',
  }, // 4th of July
  {
    month: 10,
    date: 11,
    saturdayAdjustment: 0,
    sundayAdjustment: 1,
    locale: 'en-us',
  }, // Veteran's Day
  {
    month: 11,
    date: 25,
    saturdayAdjustment: 0,
    sundayAdjustment: 1,
    locale: 'en-us',
  }, // Christmas
];

/* Movable holidays are days that have a different date each year
and instead are determined by the day/week of the month. */
const movableDateBankHolidays = [
  { month: 0, dayOfWeek: 1, weekOfMonth: 3 }, // Martin Luther King Jr Day
  { month: 1, dayOfWeek: 1, weekOfMonth: 3 }, // Presidents Day
  { month: 8, dayOfWeek: 1, weekOfMonth: 1 }, // Labor Day
  { month: 9, dayOfWeek: 1, weekOfMonth: 2 }, // Columbus Day
  { month: 10, dayOfWeek: 4, weekOfMonth: 4 }, // Thanksgiving
];

const getWeekOfMonth = (day: Moment): number => Math.ceil(day.date() / 7);

const isBankHoliday = (day: Moment): boolean => {
  if (!day) return false;

  const month = day.month();
  const date = day.date();
  const dayOfWeek = day.day();
  const weekOfMonth = getWeekOfMonth(day);
  const year = day.year();

  return (
    isStaticDateHoliday(staticDateBankHolidays, month, date, dayOfWeek, year) ||
    isMovableDateHoliday(
      movableDateBankHolidays,
      month,
      dayOfWeek,
      weekOfMonth
    ) ||
    isMemorialDay(month, date, dayOfWeek, year)
  );
};

export default isBankHoliday;
